class MyMatchingJobsController {
  constructor(JPMCService, UserDataService, ResultsService) {
    this.ResultsService = ResultsService;
    this.userData = {
      interests: UserDataService.interests,
      skills: UserDataService.skills,
      education: UserDataService.education
    };

    this.jobs = JPMCService.getAllJobs();
    this.pagination = 4;
  }
  calculateMatch() {
    for (let job of this.jobs) {
      job.match = this.ResultsService.calculateOverallMatch(job.id);
    }
  }
  seeMore() {
    if ((this.pagination + 4) > this.jobs.length) {
      this.pagination = this.jobs.length;
    } else {
      this.pagination += 4;
    }
  }
}

MyMatchingJobsController.$inject = ['JPMCService', 'UserDataService', 'ResultsService'];

export default MyMatchingJobsController;



// WEBPACK FOOTER //
// ./src/components/myMatchingJobs/myMatchingJobs.controller.js